import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "../Util/axiosConfig";
import toast from "react-hot-toast";

const SecureDownload = () => {
  const { id, token } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const downloadResource = async () => {
      try {
        const response = await axios.get(
          `/v1/api/resources/secure-download/${id}/${token}`
        );

        if (response.data.success) {
          const { downloadUrl, contentType, fileName } = response.data.data;

          // Create download element
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", fileName);
          link.setAttribute("type", contentType);

          // Trigger download
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Redirect to resources page
          toast.success("Download started!");
          setTimeout(() => history.push("/resources"), 2000);
        }
      } catch (error) {
        toast.error(
          error.response?.data?.data || "Failed to download resource"
        );
        setTimeout(() => history.push("/resources"), 2000);
      } finally {
        setLoading(false);
      }
    };

    downloadResource();
  }, [id, token, history]);

  return (
    <div className="container mt-5">
      <div className="text-center">
        {loading ? (
          <>
            <h3>Starting Download...</h3>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </>
        ) : (
          <h3>Redirecting back to resources...</h3>
        )}
      </div>
    </div>
  );
};

export default SecureDownload;
